import { toast } from "react-toastify";
import firebase from "../../config/firebase";

export const addEducation =
  (obj, onComplete = () => {}) =>
  async () => {
    try {
      obj.createdAt = firebase.firestore.Timestamp.now();
      await firebase.firestore().collection("admin-education").add(obj);
      onComplete();
      toast.success("Education add successfully");
    } catch (error) {
      onComplete("error");
      toast.error("Education not add");
    }
  };
export const getEducation =
  (lastDocument, onComplete = () => {}) =>
  (dispatch) => {
    try {
      dispatch({ type: "EDUCATION_LOADING", payload: true });

      let query = firebase
        .firestore()
        .collection("admin-education")
        .orderBy("createdAt", "desc");

      if (lastDocument) {
        query = query.startAfter(lastDocument);
      }

      const unsubscribe = query.limit(5).onSnapshot(
        (snapshot) => {
          let temp_data = [];
          snapshot.forEach((doc) => {
            temp_data.push({ ...doc.data(), id: doc.id });
          });

          dispatch({
            type: lastDocument ? "MORE_GET_EDUCATION" : "GET_EDUCATION",
            payload: {
              data: temp_data,
              lastDocument:
                snapshot.docs.length > 0
                  ? snapshot.docs[snapshot.docs.length - 1]
                  : null,
              hasMoreDocument: temp_data.length >= 5,
            },
          });
          dispatch({ type: "EDUCATION_LOADING", payload: false });
          onComplete();
        },
        (error) => {
          console.error("Error fetching education data:", error);
          dispatch({ type: "EDUCATION_LOADING", payload: false });
          onComplete("error");
          toast.error("Failed to fetch education data");
        }
      );
      return unsubscribe;
    } catch (error) {
      console.error("Error setting up education snapshot:", error);
      dispatch({ type: "EDUCATION_LOADING", payload: false });
      onComplete("error");
      toast.error("Failed to fetch education data");
    }
  };

export const deleteEducation =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      await firebase.firestore().collection("admin-education").doc(id).delete();
      onComplete();
      toast.success("Education delete successfully");
    } catch (error) {
      onComplete("error");
      toast.error("Education not delete");
    }
  };

export const editEducation =
  (obj, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      let { id, ...newObj } = obj;
      await firebase
        .firestore()
        .collection("admin-education")
        .doc(id)
        .update({
          ...newObj,
        });
      onComplete();
      toast.success("Education update successfully");
    } catch (error) {
      onComplete("error");
      toast.error("Education not update");
    }
  };
